import { useState, useEffect } from 'react';
import Breadcrumb from '../../../Common/Breadcrumb';
import { APIClient } from "../../../helpers/api_helper";
import { Card, Col } from 'antd';
// import IncomeVsExpenseBarChart from '../../../Charts/IncomeVsExpenseBarChart';
// import IncomeVsExpenseTable from './IncomeVsExpenseTable';
import IntentDrawer from '../../../Common/IntentDrawer'
import { setInitialFilterConf, setFilterData } from '../../../slices/filters/thunk'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import utils from '../../../Common/utils';
import TaxNetChart from '../../../Charts/TaxNetChart';
import TaxTable from './TaxTable';


const api = new APIClient();


const InsightsTax = () => {
  document.title = "DDV" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterdata = useSelector((state) => state.Filterdata.data)
  const [taxData, setTaxData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editedIntentId, setEditedIntentId] = useState(null);

  const loadInsightsData = () => {
    const filterdata = utils.getObjectFromURL()

    setLoading(true);
    api.get('/api/insights/tax/', filterdata)
      .then(resp => setTaxData(resp))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {
        'aggregation_period': 'month',
      },
      hidden: ['intent_type', 'intent_checkboxes_group', 'relateds_group'],
      disabled: ['search']
    }))
  }, []);

  useEffect(() => {
    loadInsightsData()
  }, [filterdata]);


  return (
    <>
      <Breadcrumb parentTitle="Vpogledi" pageTitle="DDV" />

      <IntentDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedIntentId(null);
        }}
        onDone={() => {
          loadInsightsData();
          setEditedIntentId(null);
          setOpen(false);
        }}
        onIntentChanged={() => loadInsightsData()}
        onOpenIntent={(id) => {
          setEditedIntentId(id);
          setOpen(true);
        }}
        editedIntentId={editedIntentId}
      />

      <>
        <Col xs={24} className="gutter-row">

          <Card>
            <TaxNetChart data={taxData} />
            <TaxTable
              data={taxData}
              loading={loading}
              onOpenIntent={(id) => {
                setEditedIntentId(id);
                setOpen(true);
              }}
              onShowRelated={(id) => {
                const filter = { tax_intent: id, page: 1 };
                dispatch(setFilterData(filter));
                navigate(`/intents#${new URLSearchParams(filter).toString()}`);
              }}
            />
          </Card>
        </Col>
      </>
    </>
  )
}

export default InsightsTax;
